import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=144560a6&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=js&"
export * from "./MenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=144560a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144560a6",
  null
  
)

export default component.exports